import api from "./emailTemplateApi";
import { UpdateEmailTemplateRequest } from "../../repsaApi";
import adminApi from "../admin/adminApi";

export function getAllTemplates() {
  return api.getAllTemplates();
}

export function getTemplateById(id: number) {
  return api.getTemplateById(id);
}

export function updateTemplate(id: number, subject: string, htmlBody: string) {
  const request = new UpdateEmailTemplateRequest({
    subject,
    htmlBody,
  });
  return api.updateTemplate(id, request);
}

export function sendTestEmail(templateKey: string) {
  return adminApi.sendTestEmail(templateKey);
}
